import { ServiceTimeKindType } from '@ancon/wildcat-types'

export const AsSoonAsPossibleServiceTime = {
  kind: ServiceTimeKindType.AsSoonAsPossible,
  time: '',
}
